// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"3947fac0","85":"693c86c0","156":"fbe8f69c","185":"1dedad87","200":"d1f10c3e","241":"433cc1a2","305":"c1cc06f7","565":"0a576332","616":"7964770e","749":"3377c84b","787":"c1d76d12"}[chunkId] + ".chunk.js";
};